import * as React from 'react';
const SvgExternalLink = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>

        <g>
            <path
                fill='currentColor'
                d='M4.757 16.584q-.564 0-.952-.389a1.3 1.3 0 0 1-.388-.951V4.757q0-.562.388-.951.389-.39.952-.389h4.38a.527.527 0 0 1 .542.537.53.53 0 0 1-.155.388.52.52 0 0 1-.386.158H4.757a.25.25 0 0 0-.177.08.25.25 0 0 0-.08.177v10.487q0 .096.08.176t.177.08h10.487a.25.25 0 0 0 .176-.08.25.25 0 0 0 .08-.176v-4.381a.527.527 0 0 1 .537-.542q.23 0 .388.155a.52.52 0 0 1 .158.387v4.38q0 .564-.388.952-.39.39-.951.389zM15.5 5.274 8.455 12.32a.5.5 0 0 1-.372.167.57.57 0 0 1-.381-.187.54.54 0 0 1-.181-.388q0-.206.181-.387L14.726 4.5h-2.184A.526.526 0 0 1 12 3.963q0-.229.156-.387a.52.52 0 0 1 .386-.159h3.371q.288 0 .479.192a.65.65 0 0 1 .191.478v3.372a.526.526 0 0 1-.537.541.53.53 0 0 1-.387-.155.52.52 0 0 1-.159-.386z'
            />
        </g>
    </svg>
);
export default SvgExternalLink;
